import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.css']
})
export class DialogConfirmComponent implements OnInit{

  public fName!: string;
  public fIndex: any;
  public closeResult: any;
  public dialogRef: any;
  
  constructor(private modalService: NgbModal
    ,private logger: LoggerService
    ) { 

    }

  ngOnInit() {
  }

  confirm() {
    this.dialogRef.close(this.fIndex);
  }
  cancel() {
    this.dialogRef.close();
  }

  openConfirmDialog(pIndex): void {
    this.dialogRef = this.modalService.open(this);
    // this.dialogRef.componentInstance.fName = this.files[pIndex].name;
    this.dialogRef.componentInstance.fIndex = pIndex;

    this.dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        // this.deleteFromArray(result);
      }
    });
  }

  public openModal(content: any, size: string) {
    try {
      this.modalService.open(content, { size: size, ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        if (result == 'Save click') {
          this.confirm();
        }
        this.closeResult = `Closed with: ${result}`;

      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    } catch (error) {
      this.logger.addException(error,true);
    }
  }

  public getDismissReason(reason: any): string {
    try {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    } catch (error) {
      this.logger.addException(error,true);
      return `with: ${reason}`;
    }
  }
}
